import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LISTA_EMBARCACIONES_QRY} from '@app/services/embarcaciones.service';
import { Apollo} from 'apollo-angular';
import { Subscription } from 'rxjs/Subscription';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@app/services/notification.service';
import { tap, delay, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NavigationStart } from '@angular/router';
import { OnDestroy } from '@angular/core';
import gql from 'graphql-tag';
import { fromEvent } from 'rxjs';
import { FormControl } from '@angular/forms';




@Component({
  selector: 'app-embarcaciones',
  templateUrl: './embarcaciones.component.html',
  styleUrls: ['./embarcaciones.component.css']
})
export class EmbarcacionesComponent implements OnInit, OnDestroy {


  
  listaEmbarcaciones: any[] = [];
  loading = false;
  texto2 = '';
  texto = new FormControl();

  total = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  private routeSub: any;
  private querySubscription: Subscription;
  GQL: any;
  @ViewChild('content') content: ElementRef;
  
  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,

  ) {}
  ngOnInit(): void {
    this.initForm();
  this.traerEmbarbaciones();

   }
   initForm() {
    this.texto.setValue("");
    
  }

   loadQuery() {
    this.GQL =  gql`
    query listaEmbarcaciones {
      listaEmbarcaciones (
         keyword: "${this.texto.value}"
          pageSize: ${this.pageSize}
          pageIndex: ${this.pageIndex}
          ){ embarcaciones{
              nombre
              nic
              resoluciones{
                tvempCodPaTipvinemp
              }
              polizasVigentes
              patentes{
                patNumero
               }
      }
      total
      }}
  `;
   }


   traerEmbarbaciones(pageEvent: PageEvent = null){
     this.loadQuery();
      this.loading = true;
      if (pageEvent) {
        this.pageIndex = pageEvent.pageIndex;
        this.pageSize = pageEvent.pageSize;
        }
        this.loadQuery();

      this.querySubscription = this.apollo.watchQuery<any>({
      query: this.GQL,
    })
      .valueChanges.pipe(
        tap(() => console.log('Wait 5 seconds')),
        delay(500),
    ).subscribe(({ data, loading }) => {
      this.listaEmbarcaciones = data.listaEmbarcaciones.embarcaciones;
      this.total = data.listaEmbarcaciones.total;
      this.loading = false;
      console.log('Embarcaciones traidas');
    },
      (error) => {
        console.log(error);
        this.notificationService.showNotification('Datos invalidos', 'Datos invalidos', 'warning');
      });
  }

  applyFilter(event: Event) {
    this.texto2 = (event.target as HTMLInputElement).value;

    this.traerEmbarbaciones();

     }

  verDetalle( row: any){
    console.log(row);
    this.router.navigate(['/embarcacion/' + row.nic]);
  }
   public ngOnDestroy() {
    console.log('destroying');
    this.querySubscription.unsubscribe();
  }

}
